var ScrollFade = function(prop){
    // conf: {
    //     animSpeed: 400,
    //     headHeight: 0
    // },
    this.init= function(prop) {
    // this.init= function(n, before_class, after_class,func) {
        var th = this;
        // var conf = th.conf;
        switch(prop.type) {
            case "fadeVisible":
                var finished = false;
                var exeFade = function(before_class,after_class) {
                    // console.log(typeof(after_class));
                    $("."+before_class).each(function(){
                        var imgPos = $(this).offset().top;
                        var scroll = $(window).scrollTop();
                        var windowHeight = $(window).height();
                        if (scroll > (imgPos-50) - windowHeight + windowHeight/10){
                            $(this).addClass(prop.after_class);
                            finished = true;
                        }
                    });
                }
                $(window).on('load',function() {
                    if(!finished) exeFade(prop.before_class,prop.after_class);
                });
                $(window).on('resize',function() {
                    if(!finished) exeFade(prop.before_class,prop.after_class);
                });
                $(window).scroll(function (){
                    if(!finished) exeFade(prop.before_class,prop.after_class);
                });
                break;
            case "fadeCustom":
                var finished = false;
                var exeFade = function(before_class,after_class,func) {
                    // console.log(typeof(prop.after_class));
                    $("."+prop.before_class).each(function(){
                        var imgPos = $(this).offset().top;
                        var imgHeight = $(this).height();
                        var scroll = $(window).scrollTop();
                        var windowHeight = $(window).height();
                        // console.log(scroll +">"+( (imgPos-50) - windowHeight + windowHeight/10));
                        if (scroll > (imgPos+imgHeight-50) - windowHeight + windowHeight/10){
                            func($(this));
                            $(this).addClass(prop.after_class);
                            finished = true;
                        }
                    });
                }
                $(window).on('load',function() {
                    if(!finished) exeFade(prop.before_class,prop.after_class,prop.func);
                });
                $(window).on('resize',function() {
                    if(!finished) exeFade(prop.before_class,prop.after_class,prop.func);
                });
                $(window).scroll(function (){
                    // if(!finished) exeFade(prop.before_class,prop.after_class,prop.func);
                    exeFade(prop.before_class,prop.after_class,prop.func);
                });
                break;
            case "fadeBackground":
                var exeFade = function(before_class,after_class) {
                    if(typeof(prop.after_class)=="object") {
                        // console.log("kiya")
                    }
                    $("."+prop.before_class).each(function(){
                        var imgPos = $(this).offset().top;
                        var imgHeight = $(this).height();
                        var imgPosH = imgPos + imgHeight;
                        var scroll = $(window).scrollTop();
                        var windowHeight = $(window).height();
                        // console.log(scroll +">"+ (imgPosH+50)+"-"+windowHeight+"+"+(windowHeight/10));
                        if (scroll > (imgPos-50) - windowHeight + windowHeight/10 || scroll > (imgPosH+50) + windowHeight - windowHeight/10){
                            if(typeof(prop.after_class)=="object") {
                                prop.after_class.elem.addClass(prop.after_class.class);
                            }else {
                                $(this).addClass(prop.after_class);
                            }
                        }else {
                            if(typeof(prop.after_class)=="object") {
                                prop.after_class.elem.removeClass(prop.after_class.class);
                            }else {
                                $(this).addClass(prop.after_class);
                            }
                        }
                    });
                }
                $(window).on('load',function() {
                    exeFade(prop.before_class,prop.after_class);
                });
                $(window).on('resize',function() {
                    exeFade(prop.before_class,prop.after_class);
                });
                $(window).scroll(function (){
                    exeFade(prop.before_class,prop.after_class);
                });
                break;
        }
    }
    this.init(prop);
};

module.exports = ScrollFade;